export class ConvertHelper {
  public static toBoolean(str: string | null | undefined): boolean | undefined {
    if (str === undefined) {
      return undefined;
    }

    if (str) {
      return str.toLowerCase() === 'true';
    }

    return false;
  }

  public static toNumber(str: string | null | undefined): number | null | undefined {
    if (str === undefined) {
      return undefined;
    }

    if (str && !isNaN(Number(str))) {
      return Number(str);
    }

    return null;
  }
}
